export enum TransferRequestStatusEnum {
  Draft = 'Draft',
  WaitingForApproval = 'WaitingForApproval',
  Submitted = 'Submitted',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
}
